export enum EUserRoles {
  ADMIN = 1,
  MANAGER = 2,
  SUPER_ADMIN = 3,
  OPERATOR = 4,
}
